export default __webpack_public_path__ + "static/media/upload-icon.6f3f7800.svg";